






import { defineComponent } from '@vue/composition-api';

const Landing = defineComponent({
  // setup() {},
});

export default Landing;
